<template>
  <div class="block-n_05">
    <div class="s4_m">
      <div class="tagContenta sia" v-for="(scheduler,index) in schedulers" :key="index">
        <div class="div05 clearfix">
          <div class="div05-L clearfix">
            <a href=""><img :src="scheduler.img"/><!--<span>已做</span>--></a>

          </div>
          <div class="div05-R clearfix">
            <h3>{{scheduler.treatmentNames}}</h3>
            <div class="top-space"></div>
            <div v-if="scheduler.totalPoint > 0"><span>{{scheduler.totalPoint}}积分</span>抵扣<span>{{scheduler.pointDeduction}}元</span><br/></div>
            <div v-if="scheduler.totalCoupon > 0"><span>{{scheduler.totalCoupon}}优惠卷</span>抵扣<span>{{scheduler.totalCoupon}}元</span><br/></div>
            <div v-if="scheduler.totalGold > 0"><span>{{scheduler.totalGold}}华韩金</span>抵扣<span>{{scheduler.totalGold}}元</span><br/></div>
            <div> 实付：<span>{{scheduler.totalPrice}}元</span></div>
            <p class="p03">{{scheduler.beginTime}}至{{scheduler.endTime}}</p>
          </div>
        </div>

        <div class="clear"></div>
      </div>
      <div class="tagContenta" v-if="showTip">
        <div class="div05 clearfix" id="div05">
          <div class="div06">
            <img src="../../../static/img/L.png"/><br/>您还没有待做的项目！
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import schedulerService from '../../services/scheduler-service'
  import {Toast} from 'mint-ui'

  export default {
    data () {
      return {
        schedulers: [],
        showTip: false
      }
    },
    methods: {
      getDateTime (data) {
        const time = new Date(data)
        return time.getFullYear() + '-' + (time.getMonth() + 1) + '-' + time.getDate() + ' ' + time.getHours() + ':' + (time.getMinutes() < 10 ? '0' + time.getMinutes() : time.getMinutes())
      },
      getTime (data) {
        const time = new Date(data)
        return time.getHours() + ':' + (time.getMinutes() < 10 ? '0' + time.getMinutes() : time.getMinutes())
      }
    },
    created () {
      const params = {
        customerId: this.$store.getters.customerId,
//        customerId: 712992,
        schedulerStatus: 'WAITING'
      }
      schedulerService.getSchedulers(params).then((res) => {
        if (res.statusCode == 200) {
          if (res.data.length == 0) {
            this.showTip = true
          } else {
            this.schedulers = res.data
            for (let i in res.data) {
              if (res.data[i].schedulerStatus == 'DONE') {
                res.data[i].img = '../../../static/img/yz.png'
              } else if (res.data[i].schedulerStatus == 'APPLYING') {
                res.data[i].img = '../../../static/img/sqz.png'
              } else if (res.data[i].schedulerStatus == 'WAITING') {
                res.data[i].img = '../../../static/img/dz.png'
              }
              res.data[i].beginTime = this.getDateTime(res.data[i].beginTime)
              res.data[i].endTime = this.getTime(res.data[i].endTime)
            }
          }
        } else {
          Toast(res.message)
        }
      }).catch((err) => {
        console.log(err)
      })
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/scheduler/Waiting.vue